import {Component, Input, OnInit, TemplateRef} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {CrudMarketsService} from '../../../../shared/services/crud-markets.service';

@Component({
  selector: 'app-markets-ellipsis',
  templateUrl: './markets-ellipsis.component.html',
  styleUrls: ['./markets-ellipsis.component.scss']
})
export class MarketsEllipsisComponent implements OnInit {

  private confirmDialog: BsModalRef;

  @Input() idvaluechild: string;
  @Input() entityroot: string;
  @Input() httpcrud: any;

  constructor(
    protected modalservice: BsModalService,
    protected router: Router,
    protected http: HttpClient,
    private marketservice: CrudMarketsService
  ) { }

  ngOnInit(): void {
  }

  editEntity() {
    const editUrl = this.entityroot + '/' + this.idvaluechild + '/edit';
    console.log(editUrl);
    this.router.navigate([editUrl]);
  }

  confirmEntityDeletion() {
    // Delete action
    this.marketservice.removeEntity(this.idvaluechild).subscribe( (data) => {
      // Close dialog
      this.confirmDialog.hide();
    });

  }

  confirmRemoveDialog(confirmtemplate: TemplateRef<any>) {
    this.confirmDialog = this.modalservice.show(confirmtemplate);
  } // confirmRemoveDialog

  // Method called by the template
  closeConfirmRemoveDialog() {
    this.confirmDialog.hide();
  } // closeConfirmRemoveDialog

}
